RivalIQ.module('graph', function (graph, App, Backbone, Marionette, $, _, d3) {

    'use strict';

    const Distribution = graph.Distribution = graph.Block.extend({
        className: 'distribution',
        margin: {
            top: 30,
            right: 10,
            bottom: 30,
            left: 10
        },

        renderData: function (svg, data) {
            const me = this;

            const offsetHeight = me.dimensions.height - Distribution.X_AXIS_HEIGHT;
            const halfOffsetHeight = offsetHeight / 2;

            const stack = d3.layout.stack();
            data = stack(_.map(data, function (row, i) {
                return _.map(row, function (d) {
                    let y = d.value * (i === 0 ? -1 : 1);
                    // HACK to make sure 0 labels show up on the correct side
                    // of the axis
                    y = (y === 0 ? 0.1e-5 * i : y);
                    return {
                        x: d.label,
                        y: y,
                        data: d
                    };
                });
            }));

            const x = d3.scale.ordinal()
                .rangeRoundBands([0, me.dimensions.width], 0.45);

            const y = d3.scale.linear()
                .range([-halfOffsetHeight, 0]);

            const height = d3.scale.linear()
                .range([0, halfOffsetHeight]);

            let yMax = d3.max(data, function (row) {
                return d3.max(row, function (d) { return d.data.value; });
            });

            // NOTE in order for the height to be determined correctly the max
            // must be greater than the min (i.e., the current height domain
            // begins at zero)
            if (yMax === 0) {
                yMax = 1;
            }

            const label = d3.scale.linear()
                .range([-halfOffsetHeight, halfOffsetHeight]);

            x.domain(_.head(data).map(function (d) { return d.data.label; }));
            y.clamp(true).domain([-1 * yMax, 0]);
            height.domain([0, yMax]);
            label.domain([-yMax, yMax]);

            const xAxes = [createXAxis(x, 'bottom'), createXAxis(x, 'top', function () { return ''; })];

            const axes = svg.selectAll('.x.axis')
                .data(data);

            axes.enter().append('g')
                .attr('class', 'x axis')
                .append('g')
                .attr('class', 'group');

            axes
                .attr('transform', function (d, i) {
                    return `translate(0,${halfOffsetHeight + i * Distribution.X_AXIS_HEIGHT})`;
                })
                .each(function (node, i) {
                    d3.select(this).call(xAxes[i]);
                });

            const bars = axes.selectAll('.bar')
                .data(_.identity);

            bars.enter().append('g')
                .attr('class', 'bar')
                .each(function () {
                    const node = d3.select(this);
                    node.append('rect');
                    node.append('text')
                        .attr('class', 'label');
                });

            bars.selectAll('rect')
                .attr('x', function (d) { return x(d.x); })
                .attr('y', function (d) { return y(d.y); })
                .attr('class', function (d) { return d.data.className; })
                .attr('height', function (d) { return height(d.data.value); })
                .attr('width', x.rangeBand());

            bars.selectAll('text')
                .text(function (d) {
                    const formatter = (d.data.formatter || me.formatter || RivalIQ.formatter.formats.abbreviated);
                    return formatter(d.data.value);
                })
                .attr('x', function (d) { return x(d.x) + (x.rangeBand() / 2); })
                .attr('y', function (d) {
                    const y = label(d.y);
                    return (y <= 0 ? y - Distribution.LABEL_PADDING : y + Distribution.LABEL_PADDING);
                });
        }
    });

    Distribution.LABEL_PADDING = 15;
    Distribution.X_AXIS_HEIGHT = 26;

    function createXAxis(x, orient, tickFormat) {

        const axis = d3.svg.axis()
            .scale(x)
            .orient(orient);

        if (tickFormat) {

            axis.tickFormat(tickFormat);
        }

        return axis;
    }

}, window.d3);
